import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=3652a4de&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
import style0 from "./Document.vue?vue&type=style&index=0&id=3652a4de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652a4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3652a4de')) {
      api.createRecord('3652a4de', component.options)
    } else {
      api.reload('3652a4de', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=3652a4de&scoped=true", function () {
      api.rerender('3652a4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Result/Document.vue"
export default component.exports